import { supabase } from '@/integrations/supabase/client';

/** Fire-and-forget admin notification on any form submission. Never blocks the user. */
export function notifyFormSubmission(formType: string, payload: Record<string, unknown>) {
  try {
    supabase.functions
      .invoke('notify-form-submission', {
        body: {
          formType,
          payload,
          sourceUrl: typeof window !== 'undefined' ? window.location.href : undefined,
        },
      })
      .catch((e) => console.warn('notify-form-submission failed', e));
  } catch (e) {
    console.warn('notify-form-submission failed', e);
  }
}
